module.exports = __webpack_public_path__ + "img/section1SwiperTab4.12bd8106.png";